module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/lead_image2-54f886ac6871b48cfb01729815fc4031.jpg";